import { api } from './api';

export const promptsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPrompts: builder.query({
      query: (params = {}) => {
        const { page = 1, limit = 50, search } = params;
        const queryParams = {
          page,
          limit,
          ...(search && { search }),
        };
        return { url: '/admin/prompts', params: queryParams };
      },
    }),
    /**
     * Queue a background import for an admin-created prompt.
     * Body shape: { prompt: string, imageUrls: string[], model?: string, categoryIds?: number[] }
     */
    queuePromptImport: builder.mutation({
      query: (body) => ({
        url: '/admin/prompts/queue-import',
        method: 'POST',
        body,
      }),
    }),
    deletePrompt: builder.mutation({
      query: (id) => ({
        url: `/admin/prompts/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetPromptsQuery,
  useQueuePromptImportMutation,
  useDeletePromptMutation,
} = promptsApi;

